import React from 'react';

function OdysseyLogo() {
  return (
    <div style={{
      fontFamily: "'Arial Black', 'Helvetica Neue', Arial, sans-serif",
      fontWeight: 900,
      fontSize: '26px',
      color: '#ffffff',
      lineHeight: 1,
    }}>
      Odyssey Solutions
    </div>
  );
}

export default function Header() {
  return (
    <header className="app-header">
      <div className="header-inner">
        <div className="header-brand">
          <OdysseyLogo />
          <div style={{ marginLeft: 10 }}>
            <div className="header-subtitle">HIPAA Compliance Training</div>
          </div>
        </div>
        <div className="header-badge">HIPAA Compliance Training Portal</div>
      </div>
    </header>
  );
}
